/**
 * Text component for canvas rendering.
 * Uses StreamdownMessage for markdown content (same renderer as chat messages).
 */

import React, { memo } from 'react';
import type { TextProps as TextPropsType } from '../../../types/canvas';
import { StreamdownMessage } from '../../ai/StreamdownMessage';

export interface TextComponentProps extends TextPropsType {}

function TextComponentBase({ content, variant = 'body', format = 'plain' }: TextComponentProps) {
  const variantStyles = {
    body: 'text-base text-gray-700 dark:text-gray-200',
    heading: 'text-xl font-semibold text-gray-900 dark:text-white',
    caption: 'text-sm text-gray-500 dark:text-gray-400',
    code: 'font-mono text-sm bg-gray-100 dark:bg-gray-800 dark:text-gray-200 px-2 py-1 rounded',
  };

  if (variant === 'code') {
    return (
      <pre className={variantStyles[variant]}>
        <code>{content}</code>
      </pre>
    );
  }

  // Use StreamdownMessage for markdown (same streaming markdown as chat)
  if (format === 'markdown') {
    return (
      <div className={variantStyles[variant]}>
        <StreamdownMessage content={content} />
      </div>
    );
  }

  const Tag = variant === 'heading' ? 'h2' : 'p';
  return <Tag className={variantStyles[variant]}>{content}</Tag>;
}

export const TextComponent = memo(TextComponentBase);
